export default __webpack_public_path__ + "static/SRUS AP680 - Product Specifications & Technical Data-db108d971f01ee9c54d7d111f8722d88.pdf";